
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e56c5f04!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CaseStudy.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CaseStudy.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e56c5f04!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CaseStudy.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/spa/CaseStudy/CaseStudy.vue
// module id = 255
// module chunks = 0